import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import one from '../assets/1.png';
import two from '../assets/2.png';
import three from '../assets/3.png';
import four from '../assets/4.png';
import five from '../assets/5.png';
import six from '../assets/6.png';
import seven from '../assets/7.png';
import eight from '../assets/8.png';
import nine from '../assets/9.png';
import StepWizard from 'react-step-wizard';
import { Alert, DConnect, DecryptData, getCookie } from '../components/Config';
import _ from 'lodash'
import Login from './application/Login';
import BusinessDetails from './application/BusinessDetails';
import OwnerDetails from './application/OwnerDetails';
import Financials from './application/Financials';
import Confirmation from './application/Confirmation';
import BusinessContacts from './application/BusinessContacts';
import Performance from './application/Performance';
import Shareholder from './application/Shareholder';
import CovidImpact from './application/CovidImpact';
import OwnerContacts from './application/OwnerContacts';
import Expenditure from './application/Expenditure';
import ExpectedResult from './application/ExpectedResult';
import TechnicalAssistance from './application/TechnicalAssistance';
import { LTitleBar } from '../components/DefaultLayout';
import DocUpload from './application/DocUpload';


function Application(props) {
    const [registration, setRegistration] = useState({
        idtype: 0, idno: '', firstname: '', lastname: '', bus_phone: '', bus_name: '', reg_code: '',
        tourism: '', reg_formerly: '', is_smeg: '', busplan_expiry: null, createdon: new Date(), modifiedon: new Date(), modifiedby: '', app_num: '', id: 0
    });
    const [properties, setProps] = useState([]);
    const [position, setPosition] = useState({ id: 0, app_num: '', ma_stage: 0, ss_stage: 0, bp_stage: 0 });

    const [businessDetails, setBusinessDetails] = useState({
        id: 0, app_num: '', bus_name: '', bus_tin: '', date_commenced: null, date_registered: null, operation_status: 0, bus_type: 0, org_age_bracket: 0, emp_size_fulltime_male: 0, emp_size_fulltime_female: 0,
        emp_size_partime_male: 0, emp_size_partime_female: 0, numofemp_ltage18: 0, numofemp_btwage18and35: 0, numofemp_btwage36and45: 0, numofemp_gte_age46: 0, region: 0, district: 0, town: '',
        landmark: '', address_email: '', association: '0', assoc_name: '', female_dominated: 0, corporatebankacc: 0, location: '', gps: '', address_postal: '', mobile: '', phone: '', bus_sector: 0, other_sector: '',
        getp3sector: '', getp3subsector: '', getp3sector_other: '', bus_profile: '', covidimpact: '', operation_risk: '', enterprise_challenges: '', challenge_alleviation: '', grant_reason: '', iscovidimpact: 0, tech_assistance: 0, explain_reason: '',
        other_reason: '', idcard1image: '', idcard2image: '', inc_certificate: '', lt180k2019: 0, btw180kand7200k2019: 0, btw7200kand21600k2019: 0, over21600k2019: 0, lt180k2020: 0, btw180kand7200k2020: 0, btw7200kand21600k2020: 0,
        over21600k2020: 0, lt180k2021: 0, btw180kand7200k2021: 0, btw7200kand21600k2021: 0, over21600k2021: 0, lt180k2022: 0, btw180kand7200k2022: 0, btw7200kand21600k2022: 0, over21600k2022: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: ''
    });

    const [shareholdings, setShareholdings] = useState([]);
    const [performance, setPerformance] = useState({
        id: 0, app_num: '', isexport2019: 0, isexport2020: 0, isexport2021: 0, turnover2019: 0, turnover2020: 0, turnover2021: 0, turnover2022: 0, emp_size_fulltime_male2019: 0, emp_size_fulltime_male2020: 0,
        emp_size_fulltime_male2021: 0, emp_size_fulltime_male2022: 0, emp_size_fulltime_female2019: 0, emp_size_fulltime_female2020: 0, emp_size_fulltime_female2021: 0, emp_size_fulltime_female2022: 0, emp_size_partime_male2019: 0, emp_size_partime_male2020: 0,
        emp_size_partime_male2021: 0, emp_size_partime_male2022: 0, emp_size_partime_female2019: 0, emp_size_partime_female2020: 0, emp_size_partime_female2021: 0, emp_size_partime_female2022: 0, empwithage_lt182019: 0, empwithage_lt182020: 0, empwithage_lt182021: 0,
        empwithage_lt182022: 0, empwithage_btw18and352019: 0, empwithage_btw18and352020: 0, empwithage_btw18and352021: 0, empwithage_btw18and352022: 0, empwithage_btw36and452019: 0, empwithage_btw36and452020: 0, empwithage_btw36and452021: 0, empwithage_btw36and452022: 0, 
        empwithage_gte46_2019: 0, empwithage_gte46_2020: 0, empwithage_gte46_2021: 0, empwithage_gte46_2022: 0, exports2019: 0, exports2020: 0, exports2021: 0, exports2022: 0, domesticimport2019: 0, domesticimport2020: 0, domesticimport2021: 0, directimport2019: 0, directimport2020: 0,
        directimport2021: 0, indirectimport2019: 0, indirectimport2020: 0, indirectimport2021: 0, pregrant_support_turnover: '', postgrant_support_turnover: '', expected_changes_turnover: '', pregrant_support_exployeesize: '',
        postgrant_support_exployeesize: '', expected_changes_exployeesize: '', pregrant_support_exports: '', postgrant_support_exports: '', expected_changes_exports: '', pregrant_support_others: '',
        postgrant_support_others: '', expected_changes_others: '', incstatement: '', createdon: new Date(), modifiedon: new Date(), modifiedby: ''
    });

    const [branches, setBranches] = useState([]);
    const [covidImpactDetails, setCovidImpactDetails] = useState([]);
    const [ownerDetails, setOwnerDetails] = useState(
        {
            id: 0, app_num: '', firstname: '', lastname: '', othernames: '', address_res: '', address_postal: '', gps: '', landmark: '', mobile: '', phone: '',
            address_email: '', region: 0, district: 0, town: '', idtype: 0, idno: '', gender: 0, age_bracket: 0, birth_date: '', female_dominated: 0, disability: 0, idimage: '',
            isapplicant_owner: 1, rep_address_res: '', rep_idno: '', rep_idtype: 0, rep_gps: '', rep_name: '',
            rep_phone: '', rep_email: '', rep_title: '', createdon: new Date(), modifiedby: '', modifiedon: new Date()
        }
    );

    const [expenditures, setExpenditures] = useState([
        { id: 0, app_num: '', item: 0, item_other: '', quantity: 0, unitcost: 0, amount: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: '' },
        { id: 0, app_num: '', item: 0, item_other: '', quantity: 0, unitcost: 0, amount: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: '' },
        { id: 0, app_num: '', item: 0, item_other: '', quantity: 0, unitcost: 0, amount: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: '' }
    ]);
    const [expectedResults, setExpectedResults] = useState(performance);
    const [techAssistance, setTechAssistance] = useState([]);
    const [techOther, setTechOther] = useState({ 'development': '', 'heardAbout': '' });
    const [heardAbouts, setHeardAbouts] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);
    const area = getCookie('area') !== null ? parseInt(getCookie('area')) : 0;
    const [financials, setFinancials] = useState(
        {
            id: 0, app_num: '', loan_attempt: 0, attempt_status: 0, previous_loan: '', loan_default: '', requested_amount: 0, getp3requested_amt: 0, isrecievedgrantbefore: 0,
            grantawardingorg: '', awardamount: 0, awardyear: 0, statement_2019: '', statement_2020: '',
            paymode: 0, bankname: '', accountname: '', accountno: '', branch: '', accopeningyear: 0, momo_num: '', momo_name: '', msdn: 0,
            disclaimer: 0, declaration: 0, consent: 0, status: 0, proformainvoice1: '', proformainvoice2: '', proformainvoice3: '', proformainvoice4: '',
            enttype: 0, class_group: null, createdon: new Date(), modifiedby: '', modifiedon: new Date()
        }
    );

    useEffect(() => {
        
        if (getCookie('registration') !== null) {
            getDropdowns(JSON.parse(getCookie('registration')).app_num);
            setRegistration(JSON.parse(getCookie('registration')))
        }
    }, []);

    const getDropdowns = (appnum) => {
        setLoading(true);
        DConnect().get(`dropdowns`).then(res => {
            let ddowns = DecryptData(res.data);

            DConnect().get(`business?appnum=${appnum}`).then(res => {
                let resdata = DecryptData(res.data);

                if (resdata.length > 0) {
                    let businessDetails = resdata[0];

                    businessDetails.association = resdata[0].association ? 1 : 0;
                    businessDetails.female_dominated = resdata[0].female_dominated ? 1 : 0;
                    businessDetails.corporatebankacc = resdata[0].corporatebankacc ? 1 : 0;
                    businessDetails.lt180k2019 = resdata[0].lt180k2019 ? 1 : 0;
                    businessDetails.btw180kand7200k2019 = resdata[0].btw180kand7200k2019 ? 1 : 0;
                    businessDetails.btw7200kand21600k2019 = resdata[0].btw7200kand21600k2019 ? 1 : 0;
                    businessDetails.over21600k2019 = resdata[0].over21600k2019 ? 1 : 0;
                    businessDetails.lt180k2020 = resdata[0].lt180k2020 ? 1 : 0;
                    businessDetails.btw180kand7200k2020 = resdata[0].btw180kand7200k2020 ? 1 : 0;
                    businessDetails.btw7200kand21600k2020 = resdata[0].btw7200kand21600k2020 ? 1 : 0;
                    businessDetails.over21600k2020 = resdata[0].over21600k2020 ? 1 : 0;
                    businessDetails.lt180k2021 = resdata[0].lt180k2021 ? 1 : 0;
                    businessDetails.btw180kand7200k2021 = resdata[0].btw180kand7200k2021 ? 1 : 0;
                    businessDetails.btw7200kand21600k2021 = resdata[0].btw7200kand21600k2021 ? 1 : 0;
                    businessDetails.over21600k2021 = resdata[0].over21600k2021 ? 1 : 0;
                    businessDetails.lt180k2022 = resdata[0].lt180k2022 ? 1 : 0;
                    businessDetails.btw180kand7200k2022 = resdata[0].btw180kand7200k2022 ? 1 : 0;
                    businessDetails.btw7200kand21600k2022 = resdata[0].btw7200kand21600k2022 ? 1 : 0;
                    businessDetails.over21600k2022 = resdata[0].over21600k2022 ? 1 : 0;

                    setBusinessDetails(businessDetails);
                }
                DConnect().get(`branch?appnum=${appnum}`).then(res => {
                    resdata = DecryptData(res.data);

                    if (resdata.length > 0) {
                        setBranches(resdata);
                    }
                    DConnect().get(`appstage?appnum=${appnum}`).then(res => {
                        let pos = DecryptData(res.data);
                        if (pos.length > 0) {
                            setPosition(pos[0]);
                        }
                    DConnect().get(`shareholding?appnum=${appnum}`).then(res => {
                        resdata = DecryptData(res.data);
                        if (resdata.length > 0) {
                            setShareholdings(resdata);
                        }
                        DConnect().get(`performance?appnum=${appnum}`).then(res => {
                            resdata = DecryptData(res.data);
                            if (resdata.length > 0) {
                                resdata[0].isexport2019 = resdata[0].isexport2019 ? 1 : 0;
                                resdata[0].isexport2020 = resdata[0].isexport2020 ? 1 : 0;
                                resdata[0].isexport2021 = resdata[0].isexport2021 ? 1 : 0;

                                setPerformance(resdata[0]);
                            }
                            DConnect().get(`owner?appnum=${appnum}`).then(res => {
                                resdata = DecryptData(res.data);


                                if (resdata.length > 0) {
                                    resdata[0].disability = resdata[0].disability ? 1 : 0;
                                    resdata[0].isapplicant_owner = resdata[0].isapplicant_owner ? 1 : 0;
                                    setOwnerDetails(resdata[0]);
                                }

                                DConnect().get(`financing?appnum=${appnum}`).then(res => {
                                    resdata = DecryptData(res.data);

                                    //alert(JSON.stringify(resdata));
                                    if (resdata.length > 0) {
                                        resdata[0].previous_loan = resdata[0].previous_loan ? 1 : 0;
                                        resdata[0].loan_default = resdata[0].loan_default ? 1 : 0;
                                        resdata[0].disclaimer = resdata[0].disclaimer ? 1 : 0;
                                        resdata[0].declaration = resdata[0].declaration ? 1 : 0;
                                        resdata[0].consent = resdata[0].consent ? 1 : 0;
                                        resdata[0].isrecievedgrantbefore = resdata[0].isrecievedgrantbefore ? 1 : 0;
                                        setFinancials(resdata[0]);
                                    }
                                    DConnect().get(`expenditure?appnum=${appnum}`).then(res => {
                                        resdata = DecryptData(res.data);

                                        if (resdata.length > 0) {
                                            if (resdata.length == 2) {
                                                resdata.push({ id: 0, app_num: '', item: 0, item_other: '', quantity: 0, unitcost: 0, amount: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: '' })
                                            } else if (resdata.length == 1) {
                                                resdata.push({ id: 0, app_num: '', item: 0, item_other: '', quantity: 0, unitcost: 0, amount: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: '' });
                                                resdata.push({ id: 0, app_num: '', item: 0, item_other: '', quantity: 0, unitcost: 0, amount: 0, createdon: new Date(), modifiedon: new Date(), modifiedby: '' });
                                            }
                                            setExpenditures(resdata);
                                        }
                                        DConnect().get(`techAssistDetails?appnum=${appnum}`).then(res => {
                                            resdata = DecryptData(res.data);

                                            if (resdata.length > 0) {
                                                let techAssist = resdata.map(rdata => {
                                                    if (rdata.assist_type == 11) {
                                                        setTechOther(prevState => ({
                                                            ...prevState, ['development']: rdata.assist_other == null ? '' : rdata.assist_other
                                                        }));
                                                    }

                                                    return rdata.assist_type;
                                                });

                                                setTechAssistance(techAssist);
                                            }

                                            DConnect().get(`grantHeardAbout?appnum=${appnum}`).then(res => {
                                                resdata = DecryptData(res.data);
                                                let filteredData = resdata.filter(row => row.app_num == appnum);
                                                resdata = filteredData;

                                                if (resdata.length > 0) {
                                                    let heardAbout = resdata.map(rdata => {
                                                        if (rdata.heard_type == 12) {
                                                            setTechOther(prevState => ({
                                                                ...prevState, ['heardAbout']: rdata.heard_other == null ? '' : rdata.heard_other
                                                            }));
                                                        }

                                                        return rdata.heard_type;
                                                    });
                                                    setHeardAbouts(heardAbout);
                                                }
                                                DConnect().get(`region`).then(res => {
                                                    let region = DecryptData(res.data);

                                                    DConnect().get(`district`).then(res => {
                                                        let district = DecryptData(res.data);

                                                        //alert(JSON.stringify(district))
                                                        let dropdowns = _.groupBy(ddowns, 'fieldname');
                                                        dropdowns['regions'] = region;
                                                        dropdowns['districts'] = district;
                                                        setDropdowns(dropdowns);
                                                        setLoading(false);
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                                });
                            });
                        });
                    });
                });
            });
        }).catch(error => {
            Alert({ title: 'Dropdowns', message: error.message, buttons: 'Ok' });
            setLoading(false);
        });
    }


    const handleChange = (area, items) => {
        //alert(JSON.stringify(area))
        if (area === 0) {
            setBusinessDetails(items);
        } else if (area === 1) {
            setShareholdings(items);
        } else if (area === 2) {
            setBranches(items);
        } else if (area === 3) {
            setPerformance(items);
        } else if (area === 5) {
            setCovidImpactDetails(items);
        } else if (area === 6) {
            setOwnerDetails(items);
        } else if (area === 7) {
            setFinancials(items);
        } else if (area === 8) {
            setExpenditures(items);
        } else if (area === 9) {
            setPerformance(items);
        } else if (area === 10) {
            setTechAssistance(items);
        } else if (area === 11) {
            setHeardAbouts(items);
        } else if (area === 12) {
            setRegistration(items);
        } else if (area === 13) {
            setTechOther(items);
        }else if (area === 14) {
            setPosition(items);
        }

    }

    const getProps = (prps) => {
        setProps(prps);
    }

    const handleClick = (pos) => {
        if (pos <= position.ma_stage) {
            $('ul.list-group li').removeClass('active');
            $(`ul.list-group li:nth-child(${pos})`).addClass('active');
            properties.goToStep(pos)
        }
    }

    const doNavigate = (itm, pos, navtype) => {
        $(`ul.list-group li:nth-child(${pos})`).addClass('active');
        if (navtype == 1) {
            //itm.nextStep();
            itm.goToStep(pos);
        } else {
            itm.previousStep();
        }

    }

    const loader = () => <div id="loader"></div>;

    if (isLoading) {
        return loader();
    } else {
        return (
            <>
                <div className="row">
                    <div className="col-12 mb-3"><LTitleBar title={"Online <span>Application Forms </span> - SME High Growth Programme"} /></div>
                    <div className="col-xs-12 col-sm-3 d-none d-md-block d-sm-block">
                        <div id="bmenu">
                            <ul className="list-group list-group-flush d-none d-md-block d-sm-block d-sm-none">
                                <ul className="list-group">
                                    <li className="list-group-item" onClick={() => handleClick(1)} >
                                        <a className="btn-floating btn-fb btn-sm"><img src={one} /></a>Business Details
                                </li>
                                    {/* <li className="list-group-item" onClick={() => handleClick(1)} >
                                    <a className="btn-floating btn-fb btn-sm"><img src={one} /></a>Business Contacts
                                </li> */}
                                    <li className="list-group-item" onClick={() => handleClick(2)} >
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={two} /></a>Shareholder
                                </li>
                                    <li className="list-group-item" onClick={() => handleClick(3)} >
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={three} /></a>Performance
                                </li>
                                    {/* <li className="list-group-item" onClick={() => handleClick(1)} >
                                    <a className="text-white btn-floating btn-fb btn-sm"><img src={one} /></a>COVID Impact
                                </li> */}
                                    <li className="list-group-item" onClick={() => handleClick(4)} >
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={four} /></a>Owner Details
                                </li>
                                    {/* <li className="list-group-item" onClick={() => handleClick(1)} >
                                    <a className="text-white btn-floating btn-fb btn-sm"><img src={one} /></a>Owner Contacts
                                </li> */}
                                    <li className="list-group-item" onClick={() => handleClick(5)} >
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={five} /></a>Financials
                                </li>
                                    <li className="list-group-item" onClick={() => handleClick(6)} >
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={six} /></a>Expenditure
                                </li>
                                    {/* <li className="list-group-item" onClick={() => handleClick(1)} >
                                    <a className="text-white btn-floating btn-fb btn-sm"><img src={one} /></a>Expected Results
                                </li> */}
                                    <li className="list-group-item" onClick={() => handleClick(7)} >
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={seven} /></a>Technical Assistance
                                </li>
                                    <li className="list-group-item" onClick={() => handleClick(8)}>
                                        <a className="text-white btn-floating btn-fb btn-sm"><img src={eight} /></a>Confirmation
                                </li>
                                </ul>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12 d-lg-none d-md-none d-sm-none">
                        <div id="smenu">
                            <ul className="list-group list-inline list-group-flush d-lg-none d-md-none">
                                <ul className="list-group list-group-horizontal">
                                    <li className="list-group-item active"><span class="round-tab"><i class="">1</i></span></li>
                                    {/* <li className="list-group-item"><span class="round-tab"><i class="">2</i></span></li> */}
                                    <li className="list-group-item"><span class="round-tab"><i class="">2</i></span></li>
                                    <li className="list-group-item"><span class="round-tab"><i class="">3</i></span></li>
                                </ul>
                                <ul className="list-group list-group-horizontal">
                                    {/* <li className="list-group-item"><span class="round-tab"><i class="">4</i></span></li> */}
                                    <li className="list-group-item"><span class="round-tab"><i class="">5</i></span></li>
                                    {/* <li className="list-group-item"><span class="round-tab"><i class="">7</i></span></li> */}
                                    <li className="list-group-item"><span class="round-tab"><i class="">6</i></span></li>
                                    <li className="list-group-item"><span class="round-tab"><i class="">7</i></span></li>
                                </ul>
                                <ul className="list-group list-group-horizontal">
                                    {/* <li className="list-group-item"><span class="round-tab"><i class="">8</i></span></li> */}
                                    <li className="list-group-item"><span class="round-tab"><i class="">9</i></span></li>
                                    <li className="list-group-item"><span class="round-tab"><i class="">10</i></span></li>
                                </ul>
                            </ul>
                        </div>
                        <div style={{ marginBottom: "16px" }}></div>
                    </div>
                    <div className="col-xs-12 col-md-9">
                        {area === 0 ?
                            <Login hashKey="login" registration={registration} handleChange={handleChange} />
                            : <StepWizard isHashEnabled isLazyMount>
                                <BusinessDetails hashKey={'business_details'} getProps={getProps} position={position} registration={registration} businessDetails={businessDetails} dropdowns={dropdowns} branches={branches} handleChange={handleChange} doNavigate={doNavigate} />
                                {/* <BusinessContacts hashKey={'business_contacts'} registration={registration} businessDetails={businessDetails} branches={branches} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate}  /> */}
                                <Shareholder hashKey={'shareholder'} getProps={getProps} position={position} registration={registration} businessDetails={businessDetails} shareholdings={shareholdings} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} />
                                <Performance hashKey={'performance_indicators'} getProps={getProps} position={position} registration={registration} businessDetails={businessDetails} performance={performance} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} />
                                {/* <CovidImpact hashKey={'iscovidimpact'} registration={registration} businessDetails={businessDetails} covidImpactDetails={covidImpactDetails} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} /> */}
                                <OwnerDetails hashKey={'owner_details'} getProps={getProps} position={position} registration={registration} businessDetails={businessDetails} ownerDetails={ownerDetails} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} />
                                {/* <OwnerContacts hashKey={'owner_contacts'} registration={registration} ownerDetails={ownerDetails} businessDetails={businessDetails} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} /> */}
                                <Financials hashKey={'financials'} getProps={getProps} position={position} registration={registration} financials={financials} businessDetails={businessDetails} dropdowns={dropdowns} expenditures={expenditures} handleChange={handleChange} doNavigate={doNavigate} />
                                <Expenditure hashKey={'expenditure'} getProps={getProps} position={position} registration={registration} financials={financials} businessDetails={businessDetails} expenditures={expenditures} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} />
                                {/* <ExpectedResult hashKey={'expected_result'} registration={registration} performance={performance} businessDetails={businessDetails} financials={financials} expectedResults={expectedResults} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} /> */}
                                <TechnicalAssistance hashKey={'technical_assistance'} getProps={getProps} position={position} techOther={techOther} registration={registration} businessDetails={businessDetails} techAssistance={techAssistance} heardAbouts={heardAbouts} dropdowns={dropdowns} handleChange={handleChange} doNavigate={doNavigate} />
                                <Confirmation hashKey={'confirmation'} getProps={getProps}  handleClick={handleClick} doNavigate={doNavigate} dropdowns={dropdowns} handleChange={handleChange} techOther={techOther}
                                    businessDetails={businessDetails} ownerDetails={ownerDetails} branches={branches} shareholdings={shareholdings}
                                    financials={financials} performance={performance} expenditures={expenditures} registration={registration}
                                    expectedResults={expectedResults} techAssistance={techAssistance} heardAbouts={heardAbouts} covidImpactDetails={covidImpactDetails} />
                            </StepWizard>}
                    </div>

                </div>

            </>
        )
    }
}


export default Application;